import { makeVar } from '@apollo/client'

/** True once the Privy SDK is mounted and the session bridge is registered. */
export const isPrivyReadyVar = makeVar(false)

/** True while Privy tokens are being exchanged for the XYRO session. */
export const isPrivyExchangingVar = makeVar(false)

/** Opens the nickname dialog when `signInPrivy` answers USERNAME_REQUIRED. */
export const isPrivyUsernameDialogOpenVar = makeVar(false)

export interface PendingAccountRestore {
  /** When the account is anonymized (ms); null when the answer had no date. */
  scheduledFor: number | null
}

/**
 * Opens the restore dialog when `signInPrivy` answers that the account waits
 * for its deletion (FE-331).
 */
export const privyRestoreAccountVar = makeVar<PendingAccountRestore | null>(
  null
)

/** Name Privy gives its embedded Solana wallet in the Wallet Standard registry. */
export const PRIVY_WALLET_NAME = 'Privy'

/**
 * Addresses of the signed-in user's Privy embedded wallets (the "Privy"
 * Wallet Standard wallet); empty for a user who signed in with an external
 * wallet. Lets Privy-free UI (the wallets dialog) offer the key export only
 * where there is a key to export.
 */
export const privyEmbeddedAddressesVar = makeVar<readonly string[]>([])
